import { formatFitmentLabel } from "./fitment.js";

const genericDescriptions = new Set([
  "",
  "-",
  "n/a",
  "na",
  "new",
  "new.",
  "used",
  "used.",
  "refurbished",
  "refurbished.",
]);

function clean(value) {
  return String(value ?? "").trim();
}

function sentenceCase(value) {
  const normalized = clean(value);

  return normalized ? `${normalized[0].toUpperCase()}${normalized.slice(1)}` : "";
}

function lower(value) {
  return clean(value).toLowerCase();
}

export function hasMeaningfulProductDescription(product) {
  const description = clean(product.description);
  const normalizedDescription = lower(description);
  const normalizedCondition = lower(product.condition);

  return (
    description.length > 12 &&
    !genericDescriptions.has(normalizedDescription) &&
    normalizedDescription !== normalizedCondition
  );
}

export function productSearchDescription(product) {
  if (hasMeaningfulProductDescription(product)) {
    return clean(product.description);
  }

  const brand = clean(product.brand);
  const name = clean(product.name);
  const category = clean(product.category);
  const condition = lower(product.condition);
  const sku = clean(product.sku);
  const fitment = formatFitmentLabel(product);
  const fitmentPhrase = fitment ? ` for ${fitment}` : "";
  const categoryPhrase = category ? `${condition || "quality"} ${category.toLowerCase()}` : "auto part";
  const skuPhrase = sku ? ` SKU ${sku}.` : "";
  const fitmentSentence = fitmentPhrase ? `${fitmentPhrase}.` : "";

  return [
    sentenceCase(`${brand} ${name}`.trim()),
    fitmentSentence,
    `${sentenceCase(categoryPhrase)} available in Kenya from Truefit Automotive Solutions.`,
    skuPhrase,
  ]
    .join(" ")
    .replace(/\s+/g, " ")
    .trim();
}

export function productMetaDescription(product) {
  const description = productSearchDescription(product);

  return description.length <= 155 ? description : `${description.slice(0, 154).trim()}...`;
}
